import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { QueryClientProvider, useQuery } from '@tanstack/react-query';
import { useGlobalStore } from '../../store/global';
import { fetchJson, queryClient } from '../../api';
import { useGlobalSettings } from '../global-settings';
import { formatPrice } from '../../utils';
function SearchItem({ ...product }) {
    const currency = useGlobalStore((state) => state.config.currency);
    const itemPrice = formatPrice(product.price_with_vat, currency, true);
    return _jsx("div", { children: "..." });
}
function Search() {
    const texts = useGlobalStore((state) => state.config.texts);
    const api = useGlobalStore((state) => state.config.api);
    const [query, setQuery] = React.useState('');
    // isLoading = first load
    // isFetching = reload
    const { data, isLoading, isFetching, isError, error, refetch } = useQuery(['product-search', query], async () => fetchJson(`${api.category.search}?query=${encodeURIComponent(query)}`), {
        enabled: false,
        staleTime: Infinity,
        keepPreviousData: true,
    });
    return (_jsx("div", { className: "collapse d-lg-block w-100 w-lg-auto mt-2 mb-0 my-lg-0", id: "searchCollapse", children: _jsxs("div", { className: "position-relative", children: [_jsx("div", { className: "search-form", children: _jsxs("form", { action: "", className: "d-flex flex-nowrap", children: [_jsx("input", { type: "search", className: "form-control", placeholder: texts['text162'], onChange: (e) => setQuery(e.target.value) }), _jsx("button", { type: "submit", className: "primary", onClick: () => refetch(), disabled: isFetching, children: texts['text1'] })] }) }), data && data.data.length > 0 && (_jsx("div", { className: "search-items", children: data.data.map((product, i) => (_jsx(SearchItem, { ...product }, `search-result-${i}`))) }))] }) }));
}
export default function SearchTemplate() {
    const { isInited } = useGlobalSettings(() => Promise.resolve());
    if (!isInited)
        return null;
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(Search, {}) }));
}
